import {
    ALOG_SUBMIT_ALOG_BEGIN,
    ALOG_SUBMIT_ALOG_SUCCESS,
    ALOG_SUBMIT_ALOG_FAILURE,
    ALOG_SUBMIT_ALOG_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitAlog(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: ALOG_SUBMIT_ALOG_BEGIN,
      });
  
      let apiurl = '/api/b/alog/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/alog/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: ALOG_SUBMIT_ALOG_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: ALOG_SUBMIT_ALOG_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitAlogError() {
    return {
      type: ALOG_SUBMIT_ALOG_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case ALOG_SUBMIT_ALOG_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitAlogPending: true,
          submitAlogError: null,
        };
  
      case ALOG_SUBMIT_ALOG_SUCCESS:
        // The request is success
        return {
          ...state,
          submitAlogPending: false,
          submitAlogError: null,
        };
  
      case ALOG_SUBMIT_ALOG_FAILURE:
        // The request is failed
        return {
          ...state,
          submitAlogPending: false,
          submitAlogError: action.data.error,
        };
  
      case ALOG_SUBMIT_ALOG_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitAlogError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/alog/redux/submitAlog.js